import { useSelector } from "react-redux";
import { getSelectedQueryModal } from "../../redux/SingleDataset/selectors";
import { ReactNode, useMemo } from "react";
import FileQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/FileQueryModal";
import LabelsQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/LabelsQueryModal";
import FolderQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/FolderQueryModal";
import IssuesQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/IssuesQueryModal";
import UserTagsQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/UserTagsQueryModal";
import OutliersQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/OutliersQueryModal";
import MislabelsQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/MislabelsQueryModal";
import DuplicatesQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/DuplicatesQueryModal";
import UniquenessQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/UniquenessQueryModal";
import LabelOutliersQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/LabelOutliersQueryModal";
import NewFilterModal from "views/pages/DataPage/CardsView/DataPageFilters/InsertionTimeModal";
import MediaStatusQueryModal from "views/pages/DataPage/CardsView/DataPageFilters/MediaStatusQueryModal";
import { Filters } from "../../types";

export const useQueryModal = (): ReactNode => {
  const selectedQueryModalData = useSelector(getSelectedQueryModal);
  return useMemo(() => {
    if (!selectedQueryModalData) {
      return null;
    }
    const { type, id } = selectedQueryModalData;
    let modal;

    // Handle regular filter types using object map
    const modalMap = {
      [Filters.FILE]: <FileQueryModal editQueryId={id} />,
      [Filters.FOLDER]: <FolderQueryModal editQueryId={id} />,
      [Filters.LABELS]: <LabelsQueryModal editQueryId={id} />,
      [Filters.ISSUES]: <IssuesQueryModal editQueryId={id} />,
      [Filters.OUTLIERS]: <OutliersQueryModal editQueryId={id} />,
      [Filters.USER_TAGS]: <UserTagsQueryModal editQueryId={id} />,
      [Filters.MISLABELS]: <MislabelsQueryModal editQueryId={id} />,
      [Filters.DUPLICATES]: <DuplicatesQueryModal editQueryId={id} />,
      [Filters.UNIQUENESS]: <UniquenessQueryModal editQueryId={id} />,
      [Filters.LABEL_OUTLIER]: <LabelOutliersQueryModal editQueryId={id} />,
      [Filters.CREATED_AT]: <NewFilterModal editQueryId={id} />,
      [Filters.MEDIA_STATUS]: <MediaStatusQueryModal editQueryId={id} />,
    };
    modal = modalMap[type as Filters];

    return modal;
  }, [selectedQueryModalData]);
};
